export default __webpack_public_path__ + "static/media/fundoCases.0c592b41.jpg";